export default "__VITE_ASSET__DdSKnGRZ__"